const AboutHero = () => {
  return (
    <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.85), rgba(37, 99, 235, 0.85)), url('https://static.readdy.ai/image/f4befc687b50546f577c3e945d9e0997/1882e24b0ec1a84a6613a9a9e4b1fa83.jpeg')`
        }}
      />
      <div className="relative z-10 text-center text-white px-4 max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">À Propos de Global Grace Engineering</h1>
        <p className="text-xl md:text-2xl font-light leading-relaxed">
          Bâtir avec excellence, restaurer avec grâce
        </p>
      </div>
    </section>
  );
};

export default AboutHero;
